import { Deserializable } from '../protocols/deserializable';
import { SubmissionAvailability } from './submission-availability';

export class MpRetirementProductSubmissionAvailability implements Deserializable {
  public variableBenefitPaymentChange!: SubmissionAvailability;

  public onDeserialize(): void {
    this.variableBenefitPaymentChange = window.injector.Deserialize.instanceOf(
      SubmissionAvailability,
      this.variableBenefitPaymentChange
    );
  }
}
